/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDiagLabInventories } from 'app/entities/diag-lab-inventory/diag-lab-inventory.reducer';
import { getEntities as getDiaglabBills } from 'app/entities/diaglab-bill/diaglab-bill.reducer';
import { getEntities as getDiagLabInventoryCheckouts } from 'app/entities/diag-lab-inventory-checkout/diag-lab-inventory-checkout.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './diag-lab-inventory-investigation.reducer';

export const DiagLabInventoryInvestigationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diagLabInventories = useAppSelector(state => state.diagLabInventory.entities);
  const diaglabBills = useAppSelector(state => state.diaglabBill.entities);
  const diagLabInventoryCheckouts = useAppSelector(state => state.diagLabInventoryCheckout.entities);
  const diagLabInventoryInvestigationEntity = useAppSelector(state => state.diagLabInventoryInvestigation.entity);
  const loading = useAppSelector(state => state.diagLabInventoryInvestigation.loading);
  const updating = useAppSelector(state => state.diagLabInventoryInvestigation.updating);
  const updateSuccess = useAppSelector(state => state.diagLabInventoryInvestigation.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/diag-lab-inventory-investigation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
    dispatch(getDiagLabInventories({}));
    dispatch(getDiaglabBills({}));
    dispatch(getDiagLabInventoryCheckouts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.consumedUses !== undefined && typeof values.consumedUses !== 'number') {
      values.consumedUses = Number(values.consumedUses);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...diagLabInventoryInvestigationEntity,
      ...values,
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
      type: diagLabInventories.find(it => it.id.toString() === values.type?.toString()),
      diaglabBill: diaglabBills.find(it => it.id.toString() === values.diaglabBill?.toString()),
      checkout: diagLabInventoryCheckouts.find(it => it.id.toString() === values.checkout?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          consumedByType: 'DOCTOR',
          ...diagLabInventoryInvestigationEntity,
          diagLab: diagLabInventoryInvestigationEntity?.diagLab?.id,
          type: diagLabInventoryInvestigationEntity?.type?.id,
          diaglabBill: diagLabInventoryInvestigationEntity?.diaglabBill?.id,
          checkout: diagLabInventoryInvestigationEntity?.checkout?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.diagLabInventoryInvestigation.home.createOrEditLabel"
            data-cy="DiagLabInventoryInvestigationCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryInvestigation.home.createOrEditLabel">
              Create or edit a DiagLabInventoryInvestigation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diag-lab-inventory-investigation-id"
                  label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.consumedUses')}
                id="diag-lab-inventory-investigation-consumedUses"
                name="consumedUses"
                data-cy="consumedUses"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.active')}
                id="diag-lab-inventory-investigation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.cursor')}
                id="diag-lab-inventory-investigation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.lastUpdated')}
                id="diag-lab-inventory-investigation-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.microSec')}
                id="diag-lab-inventory-investigation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.timestampEntry')}
                id="diag-lab-inventory-investigation-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.consumedById')}
                id="diag-lab-inventory-investigation-consumedById"
                name="consumedById"
                data-cy="consumedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.consumedByType')}
                id="diag-lab-inventory-investigation-consumedByType"
                name="consumedByType"
                data-cy="consumedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-investigation-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.diagLab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-investigation-type"
                name="type"
                data-cy="type"
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.type')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabInventories
                  ? diagLabInventories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-investigation-diaglabBill"
                name="diaglabBill"
                data-cy="diaglabBill"
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.diaglabBill')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabBills
                  ? diaglabBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-investigation-checkout"
                name="checkout"
                data-cy="checkout"
                label={translate('tinyMedicRestApp.diagLabInventoryInvestigation.checkout')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabInventoryCheckouts
                  ? diagLabInventoryCheckouts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/diag-lab-inventory-investigation"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiagLabInventoryInvestigationUpdate;
